// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".zvonok_order[data-v-3264d16e]{font-size:12px}", ""]);
// Exports
module.exports = exports;
